<template>
  <a-modal v-model="modal" title="批量更新入库仓" width="500px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form">
      <a-form-model-item
        label="入库仓"
        :labelCol="{ style: 'width: 90px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 90px );float:left'}"
      >
        <global-select
          :value.sync="formData.warehouseCode"
          requestApi="/system/lookup/data/list"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: '4PL_WAREHOUSE_DESCRIPTION', pageSize: 1000 }"
        />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="handleCancel">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import {
  apiInvWipAllocationPlanCompartmentBatchUpdateWarehouse
} from '@/api/mes/scheduling-plan/sub-warehouse-plan'

export default {
  name: 'BatchUpdateWarehouseModal',
  data () {
    return {
      modal: false,
      loading: false,
      selectedRows: [],
      formData: {
        warehouseCode: undefined
      }
    }
  },
  methods: {
    show (rows) {
      this.selectedRows = rows || []
      this.modal = true
      this.$nextTick(() => {
        this.formData.warehouseCode = undefined
        this.$refs.form && this.$refs.form.resetFields()
      })
    },
    handleCancel () {
      this.modal = false
      this.formData.warehouseCode = undefined
    },
    submit () {
      if (!this.formData.warehouseCode) {
        this.$message.warning('请选择入库仓')
        return
      }
      const lineIds = this.selectedRows.map(item => item.lineId).filter(Boolean)
      if (lineIds.length === 0) {
        this.$message.warning('请选择需要修改的数据')
        return
      }
      this.loading = true
      apiInvWipAllocationPlanCompartmentBatchUpdateWarehouse({
        lineIds,
        warehouseCode: this.formData.warehouseCode
      }).then(response => {
        if (response.code === 200) {
          this.modal = false
          this.$message.success('修改成功')
          this.$emit('handle-success')
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="less"></style>
